import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
export default {
  name: "SelectInitialOrderDialog",
  props: {
    loggedUserData: Object,
    order: Object
  },
  data: function data() {
    return {
      shown: false,
      isValidating: false,
      listOrders: [],
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      form: {
        initialOrderId: null
      }
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        return !x.initialOrderId;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchOrders();
          case 2:
            _this2.form.initialOrderId = _this2.order.initialOrderId;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed", {
        initialOrderId: this.order.initialOrderId,
        initialOrderReference: this.order.initialOrderReference
      });
    },
    fetchOrders: function fetchOrders() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/orders/".concat(_this3.order.id_order, "/initial"), "get", _this3.form, true, "api").then(function (response) {
                _this.listOrders = response.data.value;
                _this.listOrders.unshift({
                  id_order: null,
                  reference_order: ""
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get orders.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isValidating = true;
              _this = _this4;
              _context3.next = 4;
              return request("/v1/order/".concat(_this4.order.id_order, "/initial"), "put", _this4.form, true, "api").then(function (_) {
                _this.isValidating = false;
                _this.$toasted.show("Order successfully updated.", {
                  type: "success"
                });
                _this.$emit("closed", {
                  initialOrderId: _this.form.initialOrderId,
                  initialOrderReference: _this.listOrders.find(function (x) {
                    return x.id_order == _this.form.initialOrderId;
                  }).reference_order
                });
              }).catch(function (e) {
                _this.isValidating = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the initial order.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};